import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFiltersDisplay = ({
  value,
  baseFilterFamily,
  strategy
}) => {
  return /*#__PURE__*/_jsx(FiltersDisplay, {
    baseFilterFamily: baseFilterFamily,
    strategy: strategy,
    value: value
  });
};
export default StyledFiltersDisplay;